// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".setPhone-dialog-style .phoneForm-style[data-v-1b198bcc] {\n  width: 400px;\n}\n.setPhone-dialog-style .tip-style[data-v-1b198bcc] {\n  font-size: 13px;\n  color: #999;\n}\n.setPhone-dialog-style .btn-style[data-v-1b198bcc] {\n  display: flex;\n  width: 100%;\n  justify-content: center;\n  margin-top: 20px;\n}\n.setPhone-dialog-style .btn-style .el-button[data-v-1b198bcc] {\n    width: 80px;\n}\n", ""]);
// Exports
module.exports = exports;
